import { connect } from 'react-redux';
import MfaChallenge from './MfaChallenge';
import { getLoginRequest } from '../../../store/actions/auth.actions';
import { mfaError, loginInProgress} from '../../../store/selectors/auth.selector';
import { getDecryptedMfaTempData } from '../../../utils/cookieUtils';

const mapDispatchToProps = { loginRequest: getLoginRequest };

const mapStateToProps = (state) => { 
    const authError = mfaError(state);
    const isLoading = loginInProgress(state);
      
    const mfaTempData = getDecryptedMfaTempData();

    return { authError, isLoading, mfaTempData };
 };

export default connect(mapStateToProps, mapDispatchToProps)(MfaChallenge);